var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 861.5 614.5",
    style: {
      enableBackground: "new 0 0 861.5 614.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#00E4B7;}\n\t.st2{fill:#9B59B6;}\n\t.st3{fill:#3498DB;}\n\t.st4{fill:#FF488A;}\n\t.st5{fill:#C6C6C6;}\n\t.st6{fill:#34495E;}\n\t.st7{fill:none;stroke:#D6D6D6;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#9B59B6;stroke-width:3;stroke-miterlimit:10;}\n\t.st9{fill:#6F00A3;}\n\t.st10{fill:#16C4A3;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.6,497.8C13,497.8,2,486.8,2,473.2V26.6C2,13,13,2,26.6,2h808.4c13.5,0,24.6,11,24.6,24.6v446.7 c0,13.5-11,24.6-24.6,24.6H26.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.9,4c12.4,0,22.6,10.1,22.6,22.6v446.7c0,12.4-10.1,22.6-22.6,22.6H26.6C14.1,495.8,4,485.7,4,473.2V26.6 C4,14.1,14.1,4,26.6,4H834.9 M834.9,0H26.6C11.9,0,0,11.9,0,26.6v446.7c0,14.7,11.9,26.6,26.6,26.6h808.4 c14.7,0,26.6-11.9,26.6-26.6V26.6C861.5,11.9,849.6,0,834.9,0L834.9,0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M547.2,614.5H314.3c-2.7,0-4-3.2-2.2-5.1c35.3-36.5,61.1-72.5,61.2-107.1c0-1.7,1.4-3,3-3h91.7c1.6,0,3,1.3,3,2.9 c1.1,40.9,31.4,75.6,77.8,106.7C551.4,610.6,550.2,614.5,547.2,614.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "code"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M319.3,96.5H42.6c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h276.7c4.4,0,8,3.6,8,8v2 C327.3,92.9,323.7,96.5,319.3,96.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M585.8,122.5H42.6c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h543.2c4.4,0,8,3.6,8,8v2 C593.8,118.9,590.2,122.5,585.8,122.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M336.2,148.5H42.6c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h293.6c4.4,0,8,3.6,8,8v2 C344.2,144.9,340.6,148.5,336.2,148.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M108.2,174.5H42.6c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h65.6c4.4,0,8,3.6,8,8v2 C116.2,170.9,112.7,174.5,108.2,174.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M442.5,96.9h-71.3c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h71.3c4.4,0,8,3.6,8,8v2 C450.5,93.4,446.9,96.9,442.5,96.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M237.6,223.5h-195c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h195c4.4,0,8,3.6,8,8v2 C245.6,219.9,242,223.5,237.6,223.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M545.7,223.5H269c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h276.7c4.4,0,8,3.6,8,8v2 C553.7,219.9,550.1,223.5,545.7,223.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M545.7,250.5H42.6c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h503.1c4.4,0,8,3.6,8,8v2 C553.7,246.9,550.1,250.5,545.7,250.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M414.8,174.5H138.1c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h276.7c4.4,0,8,3.6,8,8v2 C422.8,170.9,419.2,174.5,414.8,174.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M450.2,277.5H42.6c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h407.6c4.4,0,8,3.6,8,8v2 C458.2,273.9,454.6,277.5,450.2,277.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.8,302.5H42.6c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h164.2c4.4,0,8,3.6,8,8v2 C214.8,298.9,211.2,302.5,206.8,302.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M353.2,302.5h-118c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h118c4.4,0,8,3.6,8,8v2 C361.2,298.9,357.6,302.5,353.2,302.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M504.1,302.5H384.6c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h119.6c4.4,0,8,3.6,8,8v2 C512.1,298.9,508.5,302.5,504.1,302.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M485.6,148.5H361.5c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h124.2c4.4,0,8,3.6,8,8v2 C493.6,144.9,490,148.5,485.6,148.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M450.2,327.5H42.6c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h407.6c4.4,0,8,3.6,8,8v2 C458.2,323.9,454.6,327.5,450.2,327.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M550.3,352.5H218.2c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h332.1c4.4,0,8,3.6,8,8v2 C558.3,348.9,554.7,352.5,550.3,352.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M169.8,352.5H42.6c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h127.3c4.4,0,8,3.6,8,8v2 C177.8,348.9,174.3,352.5,169.8,352.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M106.7,377.5H41.1c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h65.6c4.4,0,8,3.6,8,8v2 C114.7,373.9,111.1,377.5,106.7,377.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M413.2,377.5H136.6c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h276.7c4.4,0,8,3.6,8,8v2 C421.2,373.9,417.6,377.5,413.2,377.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M550.3,377.5H440c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h110.3c4.4,0,8,3.6,8,8v2 C558.3,373.9,554.7,377.5,550.3,377.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M362.4,402.5H42.6c-4.4,0-8-3.6-8-8v-2c0-4.4,3.6-8,8-8h319.8c4.4,0,8,3.6,8,8v2 C370.4,398.9,366.8,402.5,362.4,402.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M773.7,84.3h-53.2c-2.3,0-4.2-1.9-4.2-4.2v0c0-2.3,1.9-4.2,4.2-4.2h53.2c2.3,0,4.2,1.9,4.2,4.2v0 C777.9,82.4,776.1,84.3,773.7,84.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M829.8,96.4H720.5c-2.3,0-4.2-1.9-4.2-4.2v0c0-2.3,1.9-4.2,4.2-4.2h109.3c2.3,0,4.2,1.9,4.2,4.2v0 C834,94.5,832.1,96.4,829.8,96.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M777.3,108.5h-56.8c-2.3,0-4.2-1.9-4.2-4.2v0c0-2.3,1.9-4.2,4.2-4.2h56.8c2.3,0,4.2,1.9,4.2,4.2v0 C781.5,106.7,779.6,108.5,777.3,108.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M729.3,120.6h-8.8c-2.3,0-4.2-1.9-4.2-4.2v0c0-2.3,1.9-4.2,4.2-4.2h8.8c2.3,0,4.2,1.9,4.2,4.2v0 C733.5,118.8,731.7,120.6,729.3,120.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M799.7,84.5h-10c-2.3,0-4.2-1.9-4.2-4.2v0c0-2.3,1.9-4.2,4.2-4.2h10c2.3,0,4.2,1.9,4.2,4.2v0 C803.9,82.7,802,84.5,799.7,84.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M756.6,143.5h-36c-2.3,0-4.2-1.9-4.2-4.2v0c0-2.3,1.9-4.2,4.2-4.2h36c2.3,0,4.2,1.9,4.2,4.2v0 C760.8,141.6,758.9,143.5,756.6,143.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M821.4,143.5h-53.2c-2.3,0-4.2-1.9-4.2-4.2v0c0-2.3,1.9-4.2,4.2-4.2h53.2c2.3,0,4.2,1.9,4.2,4.2v0 C825.6,141.6,823.7,143.5,821.4,143.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M821.4,156.1H720.5c-2.3,0-4.2-1.9-4.2-4.2l0,0c0-2.3,1.9-4.2,4.2-4.2h100.9c2.3,0,4.2,1.9,4.2,4.2l0,0 C825.6,154.2,823.7,156.1,821.4,156.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M793.8,120.6h-53.2c-2.3,0-4.2-1.9-4.2-4.2v0c0-2.3,1.9-4.2,4.2-4.2h53.2c2.3,0,4.2,1.9,4.2,4.2v0 C798,118.8,796.2,120.6,793.8,120.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M801.3,168.7h-80.8c-2.3,0-4.2-1.9-4.2-4.2v0c0-2.3,1.9-4.2,4.2-4.2h80.8c2.3,0,4.2,1.9,4.2,4.2v0 C805.5,166.8,803.6,168.7,801.3,168.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M750.1,180.3h-29.5c-2.3,0-4.2-1.9-4.2-4.2v0c0-2.3,1.9-4.2,4.2-4.2h29.5c2.3,0,4.2,1.9,4.2,4.2v0 C754.3,178.4,752.4,180.3,750.1,180.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M780.9,180.3h-19.8c-2.3,0-4.2-1.9-4.2-4.2v0c0-2.3,1.9-4.2,4.2-4.2h19.8c2.3,0,4.2,1.9,4.2,4.2v0 C785.1,178.4,783.2,180.3,780.9,180.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M812.6,180.3h-20.1c-2.3,0-4.2-1.9-4.2-4.2v0c0-2.3,1.9-4.2,4.2-4.2h20.1c2.3,0,4.2,1.9,4.2,4.2v0 C816.8,178.4,815,180.3,812.6,180.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M808.8,108.5h-21.1c-2.3,0-4.2-1.9-4.2-4.2v0c0-2.3,1.9-4.2,4.2-4.2h21.1c2.3,0,4.2,1.9,4.2,4.2v0 C813,106.7,811.1,108.5,808.8,108.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M801.3,192h-80.8c-2.3,0-4.2-1.9-4.2-4.2l0,0c0-2.3,1.9-4.2,4.2-4.2h80.8c2.3,0,4.2,1.9,4.2,4.2l0,0 C805.5,190.1,803.6,192,801.3,192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M822.4,203.6h-64.9c-2.3,0-4.2-1.9-4.2-4.2v0c0-2.3,1.9-4.2,4.2-4.2h64.9c2.3,0,4.2,1.9,4.2,4.2v0 C826.6,201.7,824.7,203.6,822.4,203.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M742.3,203.6h-21.8c-2.3,0-4.2-1.9-4.2-4.2v0c0-2.3,1.9-4.2,4.2-4.2h21.8c2.3,0,4.2,1.9,4.2,4.2v0 C746.5,201.7,744.6,203.6,742.3,203.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M729,215.3h-8.8c-2.3,0-4.2-1.9-4.2-4.2v0c0-2.3,1.9-4.2,4.2-4.2h8.8c2.3,0,4.2,1.9,4.2,4.2v0 C733.2,213.4,731.3,215.3,729,215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M793.5,215.3h-53.2c-2.3,0-4.2-1.9-4.2-4.2v0c0-2.3,1.9-4.2,4.2-4.2h53.2c2.3,0,4.2,1.9,4.2,4.2v0 C797.7,213.4,795.8,215.3,793.5,215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M822.4,215.3h-18.2c-2.3,0-4.2-1.9-4.2-4.2v0c0-2.3,1.9-4.2,4.2-4.2h18.2c2.3,0,4.2,1.9,4.2,4.2v0 C826.6,213.4,824.7,215.3,822.4,215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M782.8,226.9h-62.3c-2.3,0-4.2-1.9-4.2-4.2l0,0c0-2.3,1.9-4.2,4.2-4.2h62.3c2.3,0,4.2,1.9,4.2,4.2l0,0 C787,225,785.1,226.9,782.8,226.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M773.6,242h-53.2c-2.3,0-4.2-1.9-4.2-4.2v0c0-2.3,1.9-4.2,4.2-4.2h53.2c2.3,0,4.2,1.9,4.2,4.2v0 C777.8,240.1,776,242,773.6,242z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M829.7,254.1H720.4c-2.3,0-4.2-1.9-4.2-4.2v0c0-2.3,1.9-4.2,4.2-4.2h109.3c2.3,0,4.2,1.9,4.2,4.2v0 C833.9,252.2,832,254.1,829.7,254.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M777.2,266.2h-56.8c-2.3,0-4.2-1.9-4.2-4.2v0c0-2.3,1.9-4.2,4.2-4.2h56.8c2.3,0,4.2,1.9,4.2,4.2v0 C781.4,264.3,779.5,266.2,777.2,266.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M729.2,278.3h-8.8c-2.3,0-4.2-1.9-4.2-4.2l0,0c0-2.3,1.9-4.2,4.2-4.2h8.8c2.3,0,4.2,1.9,4.2,4.2l0,0 C733.4,276.4,731.5,278.3,729.2,278.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M799.6,242.2h-10c-2.3,0-4.2-1.9-4.2-4.2l0,0c0-2.3,1.9-4.2,4.2-4.2h10c2.3,0,4.2,1.9,4.2,4.2l0,0 C803.8,240.3,801.9,242.2,799.6,242.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M756.5,301.2h-36c-2.3,0-4.2-1.9-4.2-4.2v0c0-2.3,1.9-4.2,4.2-4.2h36c2.3,0,4.2,1.9,4.2,4.2v0 C760.7,299.3,758.8,301.2,756.5,301.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M821.3,301.2h-53.2c-2.3,0-4.2-1.9-4.2-4.2v0c0-2.3,1.9-4.2,4.2-4.2h53.2c2.3,0,4.2,1.9,4.2,4.2v0 C825.5,299.3,823.6,301.2,821.3,301.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M821.3,313.7H720.4c-2.3,0-4.2-1.9-4.2-4.2l0,0c0-2.3,1.9-4.2,4.2-4.2h100.9c2.3,0,4.2,1.9,4.2,4.2l0,0 C825.5,311.9,823.6,313.7,821.3,313.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M793.7,278.3h-53.2c-2.3,0-4.2-1.9-4.2-4.2l0,0c0-2.3,1.9-4.2,4.2-4.2h53.2c2.3,0,4.2,1.9,4.2,4.2l0,0 C797.9,276.4,796.1,278.3,793.7,278.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M801.2,326.3h-80.8c-2.3,0-4.2-1.9-4.2-4.2l0,0c0-2.3,1.9-4.2,4.2-4.2h80.8c2.3,0,4.2,1.9,4.2,4.2l0,0 C805.4,324.5,803.5,326.3,801.2,326.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M750,338h-29.5c-2.3,0-4.2-1.9-4.2-4.2v0c0-2.3,1.9-4.2,4.2-4.2H750c2.3,0,4.2,1.9,4.2,4.2v0 C754.2,336.1,752.3,338,750,338z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M780.8,338H761c-2.3,0-4.2-1.9-4.2-4.2v0c0-2.3,1.9-4.2,4.2-4.2h19.8c2.3,0,4.2,1.9,4.2,4.2v0 C785,336.1,783.1,338,780.8,338z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M812.5,338h-20.1c-2.3,0-4.2-1.9-4.2-4.2v0c0-2.3,1.9-4.2,4.2-4.2h20.1c2.3,0,4.2,1.9,4.2,4.2v0 C816.7,336.1,814.9,338,812.5,338z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M808.7,266.2h-21.1c-2.3,0-4.2-1.9-4.2-4.2v0c0-2.3,1.9-4.2,4.2-4.2h21.1c2.3,0,4.2,1.9,4.2,4.2v0 C812.8,264.3,811,266.2,808.7,266.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M801.2,349.6h-80.8c-2.3,0-4.2-1.9-4.2-4.2l0,0c0-2.3,1.9-4.2,4.2-4.2h80.8c2.3,0,4.2,1.9,4.2,4.2l0,0 C805.4,347.8,803.5,349.6,801.2,349.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M822.3,361.3h-64.9c-2.3,0-4.2-1.9-4.2-4.2l0,0c0-2.3,1.9-4.2,4.2-4.2h64.9c2.3,0,4.2,1.9,4.2,4.2l0,0 C826.5,359.4,824.6,361.3,822.3,361.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M742.2,361.3h-21.8c-2.3,0-4.2-1.9-4.2-4.2l0,0c0-2.3,1.9-4.2,4.2-4.2h21.8c2.3,0,4.2,1.9,4.2,4.2l0,0 C746.4,359.4,744.5,361.3,742.2,361.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M728.9,372.9h-8.8c-2.3,0-4.2-1.9-4.2-4.2v0c0-2.3,1.9-4.2,4.2-4.2h8.8c2.3,0,4.2,1.9,4.2,4.2v0 C733.1,371.1,731.2,372.9,728.9,372.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M793.4,372.9h-53.2c-2.3,0-4.2-1.9-4.2-4.2v0c0-2.3,1.9-4.2,4.2-4.2h53.2c2.3,0,4.2,1.9,4.2,4.2v0 C797.6,371.1,795.7,372.9,793.4,372.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M822.3,372.9h-18.2c-2.3,0-4.2-1.9-4.2-4.2v0c0-2.3,1.9-4.2,4.2-4.2h18.2c2.3,0,4.2,1.9,4.2,4.2v0 C826.5,371.1,824.6,372.9,822.3,372.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M782.7,384.6h-62.3c-2.3,0-4.2-1.9-4.2-4.2l0,0c0-2.3,1.9-4.2,4.2-4.2h62.3c2.3,0,4.2,1.9,4.2,4.2l0,0 C786.9,382.7,785,384.6,782.7,384.6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "presenting"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M828.7,82.9h-796c-5,0-9-4-9-9v-8c0-5,4-9,9-9h796c5,0,9,4,9,9v8C837.8,78.9,833.7,82.9,828.7,82.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 132.8,
    y: 114.9,
    className: "st6",
    width: 212.8,
    height: 5.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.8,
    y: 123.5,
    className: "st6",
    width: 212.8,
    height: 5.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.8,
    y: 132,
    className: "st6",
    width: 212.8,
    height: 5.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.4,
    y: 114.9,
    className: "st6",
    width: 366.3,
    height: 5.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.4,
    y: 123.5,
    className: "st6",
    width: 366.3,
    height: 5.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.4,
    y: 132,
    className: "st6",
    width: 366.3,
    height: 5.9
  })), /*#__PURE__*/React.createElement("rect", {
    x: 36.8,
    y: 361.9,
    className: "st6",
    width: 692,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.8,
    y: 378.9,
    className: "st6",
    width: 692,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.8,
    y: 396.9,
    className: "st6",
    width: 692,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.8,
    y: 332.9,
    className: "st5",
    width: 775,
    height: 22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 37.2,
    y1: 161.4,
    x2: 37.2,
    y2: 292.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 37.2,
    y1: 292.4,
    x2: 350.2,
    y2: 292.4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "43.2,283.4 90.2,206.4 118.2,253.4 165.9,206.4 221.2,269.4 251.2,251.4 283.2,270.4 350.8,199.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M480.9,237.9l3.1-62.4c-7-0.6-14.2,0.1-21.4,2.2c-9.5,2.9-17.7,8-24.1,14.7L480.9,237.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M483.6,242.4l60.7,4.3c2.3-15.8-2-32.5-13.3-45.5c-11.3-13-27.2-19.6-43.2-19.6L483.6,242.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M483,244l-38.7-40.6c-0.2,0.2-0.4,0.4-0.5,0.6c-19.9,24.2-16.4,60,7.8,79.9c24.2,19.9,60,16.4,79.9-7.8 c7-8.5,11.1-18.4,12.4-28.5L483,244z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 632.8,
    y: 191,
    className: "st1",
    width: 32.2,
    height: 106.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 669.1,
    y: 241.3,
    className: "st10",
    width: 32.2,
    height: 55.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 705.5,
    y: 153.9,
    className: "st1",
    width: 32.2,
    height: 143.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 741.8,
    y: 214,
    className: "st10",
    width: 32.2,
    height: 83.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 779.6,
    y: 225.9,
    className: "st1",
    width: 32.2,
    height: 71.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 781.1,
    y: 362,
    className: "st3",
    width: 30.6,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 746.8,
    y: 362,
    className: "st9",
    width: 30.6,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 781,
    y: 379,
    className: "st3",
    width: 30.6,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 746.7,
    y: 379,
    className: "st9",
    width: 30.6,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 781,
    y: 396,
    className: "st3",
    width: 30.6,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 746.7,
    y: 396,
    className: "st9",
    width: 30.6,
    height: 11
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebCode);
export default __webpack_public_path__ + "static/media/web_code.4b37c26100b6276976c086221022b92a.svg";
export { ForwardRef as ReactComponent };